import { ref, watch } from 'vue'

// AI助手开关状态（持久化到浏览器本地存储）
const STORAGE_KEY = 'aiAssistantEnabled'

// 从本地存储读取初始状态，默认开启
const aiAssistantEnabled = ref(localStorage.getItem(STORAGE_KEY) !== 'false')

// 状态变化时同步写入本地存储
watch(aiAssistantEnabled, enabled => {
	localStorage.setItem(STORAGE_KEY, String(enabled))
})

export { aiAssistantEnabled, STORAGE_KEY }
